import axios from 'axios';
import { getErrorMessage } from 'utils/getErrorMessage';

/** The backend answers 503 when a CMS code list the response builder needs is unavailable. */
const REFERENCE_DATA_UNAVAILABLE =
    'Customs reference data is temporarily unavailable, so the response could not be built. Please try again shortly.';

const STALE_REFERRAL =
    'This referral changed since you opened it. Reload it and review the latest version before sending.';

const SECURITY_CHECK_PENDING =
    'An attached file has not finished its security check. Wait for it to pass, then send again.';

export const describeReferralError = (error: unknown, fallback: string): string => {
    if (axios.isAxiosError(error)) {
        if (error.response?.status === 503) return REFERENCE_DATA_UNAVAILABLE;
        if (error.response?.status === 409) return getErrorMessage(error) ?? STALE_REFERRAL;
    }
    const message = getErrorMessage(error);
    if (message?.includes('VERIFIED security checks')) return SECURITY_CHECK_PENDING;
    return message ?? fallback;
};
